export default __webpack_public_path__ + "static/media/photo6.579263da.jpg";